import React, { useState, useEffect } from 'react';

/**
 * GDPR Cookie Consent Banner
 * Stores consent in localStorage
 */
export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if consent was already given
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setShowBanner(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      necessary: true,
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      necessary: true,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 animate-slide-up">
      <div className="max-w-6xl mx-auto bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl shadow-2xl border border-white/10 overflow-hidden">
        <div className="p-6">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
            {/* Cookie icon */}
            <div className="flex-shrink-0 hidden sm:block">
              <div className="w-16 h-16 bg-secondary/20 rounded-full flex items-center justify-center">
                <span className="text-3xl">🍪</span>
              </div>
            </div>

            {/* Text content */}
            <div className="flex-1">
              <h3 className="text-white font-bold text-lg mb-2 flex items-center gap-2">
                <span className="sm:hidden text-2xl">🍪</span>
                Cookie-beállítások
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                A HoppHomes weboldalon sütiket (cookie-kat) használunk a felhasználói élmény javítása és az oldal működésének biztosítása érdekében. 
                {showDetails && (
                  <span className="block mt-2">
                    <strong className="text-white">Szükséges sütik:</strong> Az oldal alapvető működéséhez szükségesek.<br/>
                    <strong className="text-white">Analitikai sütik:</strong> Segítenek megérteni, hogyan használják az oldalt.<br/>
                    <strong className="text-white">Marketing sütik:</strong> Személyre szabott tartalmak megjelenítéséhez.
                  </span>
                )}
              </p>
              <button 
                onClick={() => setShowDetails(!showDetails)}
                className="text-secondary hover:text-hover text-sm mt-2 underline"
              >
                {showDetails ? 'Kevesebb részlet' : 'Több részlet'}
              </button>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
              <button
                onClick={acceptNecessary}
                className="px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors text-sm whitespace-nowrap"
              >
                Csak szükségesek
              </button>
              <button
                onClick={acceptAll}
                className="px-6 py-3 bg-secondary hover:bg-hover text-white font-bold rounded-lg transition-colors text-sm whitespace-nowrap shadow-lg"
              >
                Összes elfogadása
              </button>
            </div>
          </div>

          {/* Privacy link */}
          <div className="mt-4 pt-4 border-t border-white/10 flex items-center justify-between text-xs text-gray-400">
            <span>Az "Összes elfogadása" gombra kattintva Ön hozzájárul minden süti használatához.</span>
            <a href="/adatkezeles" className="text-secondary hover:underline">Adatvédelmi irányelvek</a>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.5s ease-out;
        }
      `}</style>
    </div>
  );
}
